/**
 * TODO move this into MUI theme components definition as a button variant
 * SecondaryButton created during LIFT Portal development
 */

import { useTheme } from '@mui/material';

import { COLORS } from '@tbd/life-tokens';
import { TextButton } from '@tbd/lift-ui/components/TextButton';
import type { TextButtonProps } from '@tbd/lift-ui/components/TextButton';

export type SecondaryButtonProps = Omit<TextButtonProps, 'variant'>;

export function SecondaryButton({ sx, ...props }: SecondaryButtonProps) {
  const theme = useTheme();
  return (
    <TextButton
      variant="secondary"
      sx={{
        borderRadius: '4px',
        borderColor: COLORS.neutral_700,
        color: COLORS.neutral_700,
        ...theme.typography['component-bold-s'],
        ...(sx ?? {}),
      }}
      {...props}
    />
  );
}
